import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { Offer, OfferID } from '@alao-frontend/core'
import { AnalyticsOffersList } from '@alao-frontend/analytics.plugin'
import { CURRENCY_NAME } from '~/core/config/constants'

@Component
export class OffersListAnalyticsMixin extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  listPosition!: AnalyticsOffersList

  readonly viewedOffersInViewport: OfferID[] = []

  onOfferVisibilityStateChanged (
    isVisible: boolean,
    index: number,
    offer: Offer,
  ) {
    if (!isVisible || this.viewedOffersInViewport.includes(offer.id)) {
      return
    }

    const offerPosition = index + 1

    this.viewedOffersInViewport.push(offer.id)

    this.$analytics.GTM.sendEcommerceViewItemListEvent({
      offer,
      currency: CURRENCY_NAME,
      userData: this.$analytics.user.data,
      position: {
        index: offerPosition,
        name: this.listPosition,
      },
    })
  }

  /**
   * Offer card CTA or its overlay click handler
   */
  onOfferClick (
    index: number,
    offer: Offer,
  ) {
    this.$analytics.utils.setOffersListPosition(this.listPosition)
    this.$analytics.utils.setOffersIndexPosition(index + 1)

    this.$analytics.GTM.sendEcommerceSelectItemEvent({
      offer,
      currency: CURRENCY_NAME,
      userData: this.$analytics.user.data,
      position: {
        index: this.$analytics.utils.getOffersIndexPosition(),
        name: this.$analytics.utils.getOffersListPosition(),
      },
    })
  }
}
